// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"77196116","938":"b70f60e7"}[chunkId] + ".chunk.css";
};